<template>
	<div class="mainNav header-bottom-wrap">
		<div class="container">
			<div class="header-bottom">
				<!-- home-main-nav-start --->
				<home-main-nav class="home-main-nav"></home-main-nav>
				<div class="post-type-sm">
					<select>
						<option value="trending">Trending</option>
						<option value="latest">Latest</option>
						<option value="personal">Personal</option>
					</select>
				</div>
				<!-- home-main-nav-end --->

				<ul class="hb-nav-right">
					<li>
						<router-link :to="{ name: 'story-create' }" class="navitem btn active">
							Create Story <span class="navIcon">+</span>
						</router-link>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>



<script>


export default {
  name: "main-nav",

	data(){
		return{

		}
	},

	methods:{


	},

	
	
}

</script>



<style type="text/css">

	.mainNav {
		-webkit-box-shadow: none !important;
		        box-shadow: none !important;
		-webkit-box-sizing: border-box;
		        box-sizing: border-box;
	}


	.post-type-sm{
		display: none;
	}

	@media only screen and (max-width: 768px) {
		.mainNav .navitem.btn {
		    display: inherit !important;
		    padding: 2px 10px;
		}

		.post-type-sm{
			display: block !important;
		    position: relative;
		}
		.post-type-sm select{
		    font-size: 15px;
		    font-weight: 400;
		    line-height: 26px;
		    letter-spacing: 0.3214286px;
		    border: none;
		    outline: none;
		    border: #00c6c6;
		    background: transparent;
		    color: #214163;
		}

    	#mainNavWrap li:first-child:after,
		.home-main-nav,
		.mainNav .navIcon {
			display: none;
		}

	}

	/*@media screen and (min-color-index:0) and(-webkit-min-device-pixel-ratio:0)
	{ @media {
			
	}}
	
	@supports (overflow:-webkit-marquee) and (justify-content:inherit)
	{

	}


	@supports (-webkit-text-size-adjust:none) and (not (-ms-ime-align:auto)) and (not (-moz-appearance:none)) {

	}*/


	_:-webkit-full-screen:not(:root:root), .post-type-sm:after
	{
	    position: absolute;
	    content: "";
	    width: 5px;
	    height: 5px;
	    background: transparent;
	    display: block;
	    right: -4px;
	    top: 21px;
	    -webkit-transform: rotate(45deg);
	    transform: rotate(45deg);
	    border-bottom: 2px solid #214163;
	    border-right: 2px solid #214163;
	}


</style>